export interface ICalDTO{
    id: number;
    userId: number;
    url: string;
}

export interface ICalWriteDTO{
    userId: number;
    url: string;
}

export function createICal(userId: number, url:string) {
    return {userId: userId, url: url}

}